import "../assets/css/header.css";
import "../assets/css/responsive.css";
import { useTranslation } from "react-i18next";
import { useWeb3React } from "@web3-react/core";
import { connectWallet } from "../utils/connectWallet";
import Onboard from "bnc-onboard";
import { ethers } from "ethers";
import { useEffect, useState } from "react";
import imageUrl from "utils/imageUrl";
import { Link, useLocation } from "react-router-dom";

function Header(props) {
  const location = useLocation();
  const href = [
    "/rent",
    "/buy",
    "/sell",
    "/explore",
    "/profile",
    "/buy-prop-details",
    // "/admin",
  ];

  const { t, i18n } = useTranslation();
  const [lang, setLanguage] = useState("en");
  const { active, activate } = useWeb3React();
  console.log("is active check = ", active);
  const handlechange = (e) => {
    setLanguage(e.target.value);
    i18n.changeLanguage(e.target.value);
    console.log(e.target.value);
  };

  return (
    // <header>
    //   <div className="custom-header pc-header">
    //     <div className="logo-section">
    //       {/* <img src={logo} className="logo" /> */}
    //       logo
    //     </div>
    //     <div className="flex-btn-group w-50">
    //       <button className="wallet-btn" onClick={connectWalletPressed}>
    //         {t("connectwallet")}
    //       </button>
    //       {/* <button className="guide-btn">
    //         <img src={guide} />
    //         <span>{t("docs")}</span>
    //       </button>
    //       <Form.Select
    //         className="mx-3 w-25"
    //         aria-label="Default select example"
    //         onChange={handlechange}
    //         value={lang}
    //       >
    //         <option value="en">English</option>
    //         <option value="chi">Chineese</option>
    //       </Form.Select> */}
    //     </div>
    //   </div>

    //   <Navbar className="mobile-header d-none" expand="lg">
    //     <Navbar.Brand>
    //       <div className="logo-section">
    //         {/* <img src={logo} className="logo" alt="Logo" /> */}
    //         logo
    //       </div>
    //     </Navbar.Brand>
    //     <Navbar.Toggle aria-controls="basic-navbar-nav" />
    //     <Navbar.Collapse id="basic-navbar-nav">
    //       <Nav className="me-auto align-items-start">
    //         {/* <li>
    //             <Link to={"/community"}>Community Art</Link>
    //           </li>
    //           <li>
    //             <Link to={"/voting"}>Voting</Link>
    //           </li> */}
    //         <li>
    //           <button className="wallet-btn" onClick={connectWalletPressed}>
    //             Connect to Wallet
    //           </button>
    //         </li>
    //         <li>
    //           <button className="guide-btn">
    //             <span>Docs</span>
    //           </button>
    //         </li>
    //         <li>
    //           <Form.Select
    //             className="mx-3 w-25"
    //             aria-label="Default select example"
    //             onChange={handlechange}
    //             value={lang}
    //           >
    //             <option value="en">English</option>
    //             <option value="chi">Chineese</option>
    //           </Form.Select>
    //         </li>
    //       </Nav>
    //     </Navbar.Collapse>
    //   </Navbar>
    // </header>
    // <!-- ==== header start ==== -->
    <header
      className={`header ${href.includes(location.pathname) ? "pos__rel" : ""}`}
    >
      <nav className="navbar navbar-expand-xl">
        <div className="container">
          <div className="navbar__out order-2 order-xl-3">
            <div className="nav__group__btn">
              <Link to="/profile" className="log d-none d-sm-block">
                {" "}
                Profile{" "}
              </Link>
              {active ? (
                <a
                  href="javascript:void(0)"
                  className="button button--effect d-none d-sm-block"
                >
                  Connected
                </a>
              ) : (
                <a
                  href="javascript:void(0)"
                  className="button button--effect d-none d-sm-block"
                  onClick={() => {
                    connectWallet(activate, props.setErrorMessage);
                  }}
                >
                  {" "}
                  Connect Wallet
                  <i className="fas fa-wallet mx-1"></i>
                </a>
              )}
            </div>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#primaryNav"
              aria-controls="primaryNav"
              aria-expanded="false"
              aria-label="Toggle Primary Nav"
            >
              <span className="icon-bar top-bar"></span>
              <span className="icon-bar middle-bar"></span>
              <span className="icon-bar bottom-bar"></span>
            </button>
          </div>
          <Link to="/" className="navbar-brand order-xl-2">
            <img src={imageUrl("logo.png")} alt="Logo" className="logo" />
            {/* Your Logo */}
          </Link>
          <div
            className="collapse navbar-collapse order-3 order-xl-1"
            id="primaryNav"
          >
            <ul className="navbar-nav">
              <li className="nav-item ">
                <Link to={"/buy"} className="nav-link ">
                  Buy
                </Link>
              </li>
              <li className="nav-item ">
                <Link to={"/rent"} className="nav-link ">
                  Rent
                </Link>
              </li>
              <li>
                <Link to="/explore" className="nav-link">
                  Explore
                </Link>
              </li>

              <li className="nav-item d-block d-sm-none">
                <Link to="/profile" className="nav-link">
                  Profile
                </Link>
              </li>
              <li className="nav-item d-block d-sm-none">
                {active ? (
                  <div
                    style={{
                      display: "inline-block",
                      backgroundColor: "white",
                      borderRadius: "40px",
                      padding: "8px",
                      border: "1px dashed black",
                      marginLeft: "10px",
                      marginTop: "10px",
                    }}
                  >
                    Connected
                  </div>
                ) : (
                  <a
                    href="javascript:void(0)"
                    className="button button--effect button--last"
                    onClick={() => {
                      connectWallet(activate, props.setErrorMessage);
                    }}
                  >
                    Connect Wallet{" "}
                  </a>
                )}
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
    // <!-- ==== #header end ==== -->
  );
}

export default Header;
